import styled from 'styled-components';

export const Box = styled.div`
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: +1;
`;

export const Holder = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const CanvasHolder = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const Canvas = styled.canvas`
  display: block;
  width: 100%;
  height: 100%;
  cursor: default;
  touch-action: none;

  * {
    touch-action: none;
  }
`;
